import { assign } from 'xstate5';

import { logger as garnishLogger } from '@garnish/logger';

import { Action, type FetchReceiptResponse } from '../receipt.machine.types';

// ─── Actions ─────────────────────────────────────────────────────────────────

const assignReceiptData: Action<FetchReceiptResponse> = assign((_args, output) => {
  const { receipt } = output;

  if (receipt?.__typename !== 'Receipt') {
    return {};
  }

  const order = receipt.order;

  return { order };
});

const assignError: Action = assign(({ event }) => {
  const raw = 'error' in event ? event.error : 'Unknown error';
  const message = raw instanceof Error ? raw.message : String(raw);

  return { error: message };
});

// ─── Log Actions ─────────────────────────────────────────────────────────────

const logSuccessfulClaim: Action = (args) => {
  const { order, receiptId } = args.context;

  receiptMachineLog.info('Successfully claimed a receipt', { orderId: order?.id, receiptId });
};

const logFailedClaim: Action = (args) => {
  const { order, receiptId } = args.context;

  receiptMachineLog.error('Failed to claim a receipt', { orderId: order?.id, receiptId });
};

const logFailedClaimDueToUserError: Action<{ errorType: string }> = (args, params) => {
  const { order, receiptId } = args.context;

  receiptMachineLog.warn('Failed to claim a receipt due to user error', {
    errorType: params.errorType,
    orderId: order?.id,
    receiptId,
  });
};

// ─── External Actions ────────────────────────────────────────────────────────

const onSuccessfulClaim: Action = () => {};
const onAlreadyClaimed: Action = () => {};
const onExpired: Action = () => {};
const onTimeRestriction: Action = () => {};
const onNotFound: Action = () => {};
const onUnknownError: Action = () => {};

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  assignReceiptData,
  assignError,

  onSuccessfulClaim,
  onAlreadyClaimed,
  onExpired,
  onTimeRestriction,
  onNotFound,
  onUnknownError,

  logSuccessfulClaim,
  logFailedClaim,
  logFailedClaimDueToUserError,
};

// ─── Logger ───────────────────────────────────────────────────────────────────

garnishLogger.enable('RECEIPT_MACHINE');

export const receiptMachineLog = garnishLogger.extend('RECEIPT_MACHINE');
